import {
    List,
    Datagrid,
    TextField,
    EmailField,
    BooleanField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    BooleanInput,
    SelectInput,
    required,
    email,
    useRecordContext,
    Pagination,
    DateField,
    SearchInput,
    TopToolbar,
    FilterButton,
    CreateButton,
    ExportButton,
    Show,
    SimpleShowLayout,
    ShowButton,
} from 'react-admin';

// Custom field to display user role with styling
const RoleField = () => {
    const record = useRecordContext();
    if (!record) return null;
    
    const roleColor = record.role === 'admin' ? '#ff6b35' : '#4CAF50';
    const roleLabel = record.role === 'admin' ? 'Admin' : 'User';
    
    return (
        <span style={{ 
            backgroundColor: roleColor, 
            color: 'white', 
            padding: '4px 8px', 
            borderRadius: '12px', 
            fontSize: '12px',
            fontWeight: 'bold'
        }}>
            {roleLabel}
        </span>
    );
};

const userFilters = [
    <SearchInput source="q" alwaysOn placeholder="Search by name or email..." resettable />,
];

const ListActions = () => (
    <TopToolbar>
        <FilterButton />
        <CreateButton />
        <ExportButton />
    </TopToolbar>
);

// Users List View (role = 'user')
export const UserList = () => (
    <List 
        pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
        perPage={25}
        sort={{ field: 'id', order: 'DESC' }}
        filters={userFilters}
        filterDefaultValues={{ q: '' }}
        actions={<ListActions />}
        filter={{ role: 'user' }}
        title="Users"
    >
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <EmailField source="email" />
            <TextField source="phone_number" label="Phone" />
            <TextField source="company_name" label="Company" />
            <BooleanField source="email_verified" label="Email Verified" />
            <BooleanField source="phone_verified" label="Phone Verified" />
            <BooleanField source="is_active" label="Active" />
            <RoleField label="Role" />
            <DateField source="last_login_at" showTime={true} label="Last Login" />
            <DateField source="CreatedAt" showTime={true} label="Registered" />
            <ShowButton />
            <EditButton />
        </Datagrid>
    </List>
);

const UserTitle = () => {
    const record = useRecordContext();
    return <span>User {record ? `"${record.name}"` : ''}</span>;
};

export const UserShow = () => (
    <Show title={<UserTitle />}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <EmailField source="email" />
            <TextField source="phone_number" label="Phone Number" />
            <TextField source="company_name" label="Company Name" />
            <BooleanField source="email_verified" label="Email Verified" />
            <BooleanField source="phone_verified" label="Phone Verified" />
            <BooleanField source="is_active" label="Active Status" />
            <RoleField label="Role" />
            <DateField source="last_login_at" showTime={true} label="Last Login" />
            <DateField source="CreatedAt" showTime={true} label="Registration Date" />
            <DateField source="UpdatedAt" showTime={true} label="Last Updated" />
        </SimpleShowLayout>
    </Show>
);

export const UserEdit = () => (
    <Edit title={<UserTitle />}>
        <SimpleForm>
            <TextInput source="name" validate={[required()]} />
            <TextInput source="email" validate={[required(), email()]} />
            <TextInput source="phone_number" label="Phone Number" />
            <TextInput source="company_name" label="Company Name" />
            <BooleanInput source="email_verified" label="Email Verified" />
            <BooleanInput source="phone_verified" label="Phone Verified" />
            <BooleanInput source="is_active" label="Active Status" />
            <SelectInput 
                source="role" 
                choices={[
                    { id: 'user', name: 'User' },
                    { id: 'admin', name: 'Admin' },
                ]} 
                validate={[required()]}
                label="Role"
            />
        </SimpleForm>
    </Edit>
);

export const UserCreate = () => (
    <Create>
        <SimpleForm>
            <TextInput source="name" validate={[required()]} />
            <TextInput source="email" validate={[required(), email()]} />
            <TextInput source="password" type="password" validate={[required()]} />
            <TextInput source="phone_number" label="Phone Number" />
            <TextInput source="company_name" label="Company Name" />
            <BooleanInput source="email_verified" label="Email Verified" defaultValue={false} />
            <BooleanInput source="phone_verified" label="Phone Verified" defaultValue={false} />
            <BooleanInput source="is_active" label="Active Status" defaultValue={true} />
            <SelectInput 
                source="role" 
                choices={[
                    { id: 'user', name: 'User' },
                    { id: 'admin', name: 'Admin' },
                ]} 
                validate={[required()]}
                defaultValue="user"
                label="Role"
            />
        </SimpleForm>
    </Create>
); 